<template>
  <div>
    <Form
      class="form-block-popup"
      :error="error"
      :error-text="error"
      @submit="invite"
    >
      <div class="top-window">
        <div class="heading1 heading1-line">Сотрудники</div>
      </div>

      <div class="form-block w-clearfix">
        <div class="h4">Добавить сотрудников</div>
        <div class="formcell">
          <label for="invites" class="label">Введите почты для приглашения</label>
          <input
            v-model="input"
            id="invites"
            type="email"
            class="input w-input"
            placeholder="Введите почту"
            autocomplete="off"
            required
            @input="error = null"
          >

          <!--<div class="members-wrap">
            <div
              v-for="email in pendingList"
              :key="email"
              class="invite-member w-inline-block w-clearfix"
              @click="togglePending(email)"
            >
              <div class="link-text-results">{{ email }}</div>
              <div class="file-delete">
                <div class="icon-16px">
                  <CloseIcon />
                </div>
              </div>
            </div>
          </div>-->
        </div>

        <Submit
          text="Пригласить"
          usual
          small
          :loading="inviteLoad"
        />
      </div>
    </Form>
    <div>
      <div v-if="!isLoading && employees.length" class="divider" />

      <Spinner v-if="isLoading" size="large" />
      <div v-else-if="!isLoading && errorLoad" class="w-form-fail">
        <div>{{ errorLoad }}</div>
      </div>
      <transition v-else-if="employees.length" name="fade">
        <div class="form-block">
          <div class="h4">Список сотрудников</div>
          <div class="team-grid">
            <div
              v-for="employee in employees"
              :key="employee.id"
              class="team-member"
            >
              <div
                class="team-table-item tti-name"
              >
                <div><strong>{{ employee.name || 'Сотрудник' }}</strong></div>
              </div>
              <div class="team-table-item">
                <div>
                  <a
                    :href="'mailto:' + employee.email"
                    target="_blank"
                    class="link"
                  >
                    {{ employee.email }}
                  </a>
                </div>
              </div>
              <div class="team-table-item">
                <div v-if="employee.is_active" class="status inwork">
                  {{ orders(employee) }}
                </div>
                <div v-else class="status waiting">приглашен</div>
              </div>
              <div class="team-table-item tti-delete">
                <div v-if="!employee.number_of_orders_in_progress || !employee.is_active" class="delete-team-member w-inline-block" @click="fire(employee.email)">
                  <div class="icon-20px">
                    <CloseIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import Form from '@/components/Form';
  import CloseIcon from '@/icons/close.svg';
  import Spinner from 'vue-simple-spinner';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/api/parse-error';
  import declOfNum from '@/utils/formatting/decl-of-num';
  import Submit from '@/components/Submit';

  export default {
    name: 'InviteEmployee',
    components: {Submit, Form, CloseIcon, Spinner},
    data () {
      return {
        employees: [],
        isLoading: false,
        errorLoad: null,
        error: null,
        inviteLoad: false,
        input: '',
        // pendingList: [],
      };
    },
    created () {
      this.load();
    },
    methods: {
      declOfNum,
      orders (employee) {
        return `${employee.number_of_orders_in_progress} ${declOfNum(employee.number_of_orders_in_progress, ['заказ', 'заказа', 'заказов'])}`;
      },
      /*togglePending (val) {
        this.error = null;
        if (val.match(/[^@]+@[^.]+\..+/)) {
          if (this.pendingList.includes(val))
            this.pendingList = this.pendingList.filter(email => email !== val);
          else {
            this.pendingList = [...this.pendingList, val];
            this.input = '';
          }
        }
      },*/
      async load () {
        try {
          this.isLoading = true;
          const {data} = await factory('laboratory').indexInPath('employees');
          this.employees = data;
          this.isLoading = false;
        } catch (e) {
          this.errorLoad = parseError(e) || 'Что-то пошло не так.';
          this.isLoading = false;
        }
      },
      async invite () {
        this.error = null;
        if (!this.input.match(/[^@]+@[^.]+\..+/)) {
          this.error = 'Неверный формат Email';
          return;
        }

        try {
          this.inviteLoad = true;
          await factory('laboratory').postInPath('invite', {
            email: this.input,
          });
          this.input = '';
          this.inviteLoad = false;
          await this.load();
        } catch (e) {
          this.error = parseError(e) || 'Что-то пошло не так.';
          this.inviteLoad = false;
        }
      },
      async fire (email) {
        try {
          await factory('laboratory').postInPath('dismiss', {email});
          await this.load();
        } catch (e) {
          this.error = parseError(e) || 'Что-то пошло не так.';
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  textarea{
    resize: vertical;
  }

  .team-member{
    display: contents;
    .tti-name.team-table-item {
      max-width: 117px;
      word-wrap: break-word;
    }
  }

  .invite-member, .delete-team-member {
    cursor: pointer;
  }

  .form-block >>> .btn-wrap {
    width: 150px;
  }
  .form-block >>> .btn-wrap input[type=submit] {
    width: 100%;
  }

  @media screen and (max-width: 991px) {
    .team-member{
      display: flex !important;
      .tti-name.team-table-item.must-overflow {
        max-width: 100%;
      }
    }
  }
</style>
